var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrawer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#drawer_svg__clip0_1_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 3,
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 12,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 19,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 26,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 33,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#drawer_svg__filter0_d_1_4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "drawer_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 3a2 2 0 012-2h22a2 2 0 012 2v36a2 2 0 01-2 2H17a2 2 0 01-2-2V3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15 3a2 2 0 012-2h22a2 2 0 012 2v36a2 2 0 01-2 2H17a2 2 0 01-2-2V3z",
    fill: "#EDB9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 1h26-26zm26 40H15h26zm-24 0a3 3 0 01-3-3V4a3 3 0 013-3c-.552 0-1 .895-1 2v36c0 1.105.448 2 1 2zM41 1v40V1z",
    fill: "#000",
    fillOpacity: 0.21,
    mask: "url(#drawer_svg__a)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "drawer_svg__clip0_1_4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h42v42H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drawer_svg__filter0_d_1_4",
    x: 10,
    y: -2,
    width: 32,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.69 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4",
    result: "shape"
  })))));
}
export default "data:image/svg+xml;base64,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";
export { SvgDrawer as ReactComponent };